// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Fv-4","overflowing":"ReadFullNote_overflowing__3JNkb"};